import { render } from "./stocktransferPrints.vue?vue&type=template&id=b7a8866c&scoped=true"
import script from "./stocktransferPrints.vue?vue&type=script&lang=js"
export * from "./stocktransferPrints.vue?vue&type=script&lang=js"

import "./stocktransferPrints.vue?vue&type=style&index=0&id=b7a8866c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7a8866c"]])

export default __exports__